import $ from 'jquery/dist/jquery.min'


const $menuSelect = $('#js-tenants-select');
const $button = $('.js-tenants-button');
$button.hide()

$menuSelect.change(function(){
  if (this.value == '') {
    return;
  }
  const slug = this.value;
  window.location.href = window.location.pathname + '?property=' +slug + '#property-manager';
});



// WEBPACK FOOTER //
// ./web/src/app/javascripts/components/TenantsSelect.jsx